const getPartnerDetails = (uuid, partners) => partners.find(({ uuid: partnerUuid }) => partnerUuid === uuid);

export { getPartnerDetails };
